import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesViewRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-view',
	path: '/secure/project/ViewProjectRoles([!%]?[\\w]*).jspa',
};
